import React from 'react'
import classNames from 'classnames'
import _ from 'lodash'

export class SearchFail extends React.Component {
    constructor(props) {
        super(props)
    }	

    render() {
        switch (this.props.type) {
            case 'destination':
                if (this.props.format === 'endoflist') {
                    return (
                        <div className="search-fail-block header-block">
                            <p>Looks like that's all we have! But you can still add your own or ask Luna to help find more.</p>
                            <br/>
                            <div className="action-block">
                                <a className="btn btn-blue btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.DESTINATION, this.props.availableDetailSubSections.ENTRY)}>
                  ADD MY OWN
                                </a>
                                <a className="btn btn-blue btn-flex" onClick={() => alert('TODO: Hook to Assist Block')}>
                  ASK LUNA ASSIST
                                </a>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className="search-fail-block header-block">
                            <h1>A place beyond our reach</h1>
                            <p>Looks like this destination is not currently in our collection. We do not have any recommendations but you can add your own, or ask Luna Assist to do it for you.</p>
                            <img src="/assets/img/layout/failicon-destination.png"/>
                            <div className="action-block">
                                <a className="btn btn-blue btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.DESTINATION, this.props.availableDetailSubSections.ENTRY)}>
                  ADD MY OWN
                                </a>
                                <a className="btn btn-blue btn-flex" onClick={() => alert('TODO: Hook to Assist Block')}>
                  ASK LUNA ASSIST
                                </a>
                            </div>
                        </div>
                    )
                }
                break
            case 'accommodation':
                if (this.props.format === 'endoflist') {
                    return (
                        <div className="search-fail-block header-block">
                            <p>Looks like that's all we have! But you can still add your own or ask Luna to help find more.</p>
                            <br/>
                            <div className="action-block">
                                <a className="btn btn-blue btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.ENTRY)}>
                  ADD MY OWN
                                </a>
                                <a className="btn btn-blue btn-flex" onClick={() => alert('TODO: Hook to Assist Block')}>
                  ASK LUNA ASSIST
                                </a>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className="search-fail-block header-block">
                            <h1>A place beyond our reach</h1>
                            <p>Looks like this destination is not currently in our collection. We do not have any accommodation recommendations but you can add your own, or ask Luna Assist to do it for you.</p>
                            <img src="/assets/img/layout/failicon-accommodation.png"/>
                            <div className="action-block">
                                <a className="btn btn-blue btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.ENTRY)}>
                  ADD MY OWN
                                </a>
                                <a className="btn btn-blue btn-flex" onClick={() => alert('TODO: Hook to Assist Block')}>
                  ASK LUNA ASSIST
                                </a>
                            </div>
                        </div>
                    )
                }
                break
            case 'attraction':
                if (this.props.format === 'endoflist') {
                    return (
                        <div className="search-fail-block header-block">
                            <p>Looks like that's all we have! But you can still add your own or ask Luna to help find more.</p>
                            <br/>
                            <div className="action-block">
                                <a className="btn btn-blue btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.ENTRY)}>
                  ADD MY OWN
                                </a>
                                <a className="btn btn-blue btn-flex" onClick={() => alert('TODO: Hook to Assist Block')}>
                  ASK LUNA ASSIST
                                </a>
                            </div>
                        </div>
                    )
                } else {
                    return (
                        <div className="search-fail-block header-block">
                            <h1>A place beyond our reach</h1>
                            <p>Looks like this destination is not currently in our collection. We do not have any activity recommendations but you can add your own, or ask Luna Assist to do it for you.</p>
                            <img src="/assets/img/layout/failicon-activity.png"/>
                            <div className="action-block">
                                <a className="btn btn-blue btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACTIVITIES, this.props.availableDetailSubSections.ENTRY)}>
                  ADD MY OWN
                                </a>
                                <a className="btn btn-blue btn-flex" onClick={() => alert('TODO: Hook to Assist Block')}>
                  ASK LUNA ASSIST
                                </a>
                            </div>
                        </div>
                    )
                }
                break
            case 'travel':
                return (
                    <div className="search-fail-block header-block">
                        <h1>A place beyond our reach</h1>
                        <p>Looks like this destination is not currently in our collection. We do not have any transportation recommendations but you can add your own, or ask Luna Assist to do it for you.</p>
                        <img src="/assets/img/layout/failicon-travel.png"/>
                        <div className="action-block">
                            <a className="btn btn-blue btn-flex" onClick={() => this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.TRAVEL, this.props.availableDetailSubSections.ENTRY, this.props.detailSubDetail)}>
                ADD MY OWN
                            </a>
                            <a className="btn btn-blue btn-flex" onClick={() => alert('TODO: Hook to Assist Block')}>
                ASK LUNA ASSIST
                            </a>
                        </div>
                    </div>
                )
                break
            default:
                return (
                    <div className="search-fail-block header-block">
                        <h1>Oops! Looks like something went wrong.</h1>
                        <p>Please select another section or your trip to work on, we'll look into this.</p>
                    </div>
                )
                break
        }
    }
}
